import { render } from "./EmailSignIn.vue?vue&type=template&id=2da01529&scoped=true"
import script from "./EmailSignIn.vue?vue&type=script&lang=js"
export * from "./EmailSignIn.vue?vue&type=script&lang=js"

import "./EmailSignIn.vue?vue&type=style&index=0&id=2da01529&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da01529"]])

export default __exports__